module.exports = __webpack_public_path__ + "img/202403_01_sp.3c3b759a.jpg";